<template>
    <div id="app">
        <SiteHeader v-show="showHeader"
                    :white="inSectionApply"></SiteHeader>
        <LandingPage></LandingPage>
        <div class="sections-container" ref="sections">
            <SectionWhyUs></SectionWhyUs>
            <SectionWork></SectionWork>
            <SectionTalking></SectionTalking>
            <SectionJob ref="sectionJob"></SectionJob>
            <SectionQuestion></SectionQuestion>
            <SectionApply ref="sectionApply"></SectionApply>
        </div>
        <SiteFooter></SiteFooter>
    </div>
</template>

<script>
import SiteHeader from './components/Header.vue';
import LandingPage from './components/LandingPage.vue';
import SectionWhyUs from './components/SectionWhyUs.vue';
import SectionWork from './components/SectionWork.vue';
import SectionTalking from './components/SectionTalking.vue';
import SectionJob from './components/SectionJob.vue';
import SectionQuestion from './components/SectionQuestion.vue';
import SectionApply from './components/SectionApply.vue';
import SiteFooter from './components/Footer.vue';

export default {
    // test
    name: 'app',
    components: {
        SiteHeader,
        LandingPage,
        SectionWhyUs,
        SectionWork,
        SectionTalking,
        SectionJob,
        SectionQuestion,
        SectionApply,
        SiteFooter,
    },
    data: function() {
        return {
            scrollY: 0,
            sectionsTop: null,
            applyTop: null,
        }
    },
    methods: {
        handleScroll: function(){
            this.scrollY = window.scrollY;
        }
    },
    computed: {
        showHeader: function() {
            if (this.sectionsTop) {
                if (this.scrollY > this.sectionsTop - 10) {
                    return true;
                }
            }
            return false;
        },
        inSectionApply: function() {
            if (this.applyTop) {
                if (this.scrollY > this.applyTop - 10) {
                    return true;
                }
            }
            return false;
        }
    },
    mounted: function () {
        this.sectionsTop = this.$refs.sections.offsetTop;
        this.applyTop = this.$refs.sectionJob.$el.offsetTop;
    },
    created: function () {
        window.addEventListener('scroll', this.handleScroll);
    },
    destroyed: function () {
        window.removeEventListener('scroll', this.handleScroll);
    }
}
</script>

<style scope
       lang="scss">
    @import "./static/styles/palette.scss";

    .sections-container {
        border: 12px solid $blue;
    }

    .scroll-enter-active, .scroll-leave-active {
        transition: "swing" .8s;
    }
</style>



// WEBPACK FOOTER //
// app.vue?57f86214